import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    token: {
        error: {},
        value: sessionStorage.getItem('accessToken') || '',
    },
};

export const authenticationSlice = createSlice({
    name: 'authentication',
    initialState,
    reducers: {
        updateToken: (state, action) => ({
            ...state,
            token: { error: {}, value: action.payload },
        }),
        resetToken: (state, action) => ({
            ...state,
            token: { error: action.payload, value: '' },
        }),
    },
});

// Action creators are generated for each case reducer function
export const { updateToken, resetToken } =
    authenticationSlice.actions;

export default authenticationSlice.reducer;
